import { render, staticRenderFns } from "./loadingtext.vue?vue&type=template&id=19b7cbaf&scoped=true"
import script from "./loadingtext.vue?vue&type=script&lang=js"
export * from "./loadingtext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b7cbaf",
  null
  
)

export default component.exports